import type { FC } from 'react';
import { useEffect, useRef } from 'react';

import { useUserInfo } from 'state/appState/appStateHooks';

export const IntercomContainer: FC = () => {
  // Current user information
  const userInfo = useUserInfo();

  const fullName = userInfo.fullName;
  const username = userInfo.username;

  // Flag to understand if Intercom was already booted
  const hasBootedRef = useRef(false);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development' && username) {
      if (!hasBootedRef.current) {
        (window as any).Intercom('boot', {
          app_id: 'zus26ip1',
          name: fullName,
          email: username,
          created_at: new Date()
        });
        hasBootedRef.current = true;
      } else {
        (window as any).Intercom('update', {
          name: fullName,
          email: username
        });
      }
    }

    return () => {
      if (process.env.NODE_ENV !== 'development') {
        (window as any).Intercom('shutdown');
        hasBootedRef.current = false;
      }
    };
  }, [fullName, username]);

  return null;
};
